export enum DayPeriod {
  AM = 'A.M.',
  PM = 'P.M.'
}
